export default __webpack_public_path__ + "static/media/samsung-care-plus.81ced53a.png";